<template>
  <div class="store-item-details">
    <v-row>
      <v-col cols="6" md="8">
        <h1 class="text-left mx-4">Store Item : {{ store_item.item_name }}</h1>
      </v-col>
      <v-col cols="6" md="4">
        <v-btn
          v-if="currentUser.privileges.canEditStoreItemDetails"
          color="primary"
          outlined
          rounded
          small
          id="edit-storeitem"
          :to="{
            name: 'EditStoreItem',
            params: {
              store_id: $route.params.store_id,
              item_id: $route.params.item_id,
            },
          }"
        >
          Edit
          <span class="hidden-sm-and-down ml-1">Item</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-container class="mx-2 my-0">
      <v-row>
        <v-col cols="6" md="4">
          <h3 class="text-left">{{ store_item.code }}</h3>
          <p class="mb-0 text-left">Item Code</p>
        </v-col>
        <v-col cols="6" md="4">
          <h3 class="text-left">{{ store_item.store.store_name }}</h3>
          <p class="mb-0 text-left">Store</p>
        </v-col>
        <v-col cols="6" md="4">
          <h3 class="text-left">
            <span v-if="store_item.has_units">
              {{ store_item.available_quantity }}/</span>
              {{ store_item.quantity }}
              
            {{ store_item.usage_unit }}
          </h3>
          <p class="mb-0 text-left">Quantity</p>
        </v-col>
        <v-col cols="6" md="4">
          <h3 class="text-left">
            {{
              currencyFormat(store_item.latest_price || store_item.unit_price)
            }}
            <v-tooltip v-if="store_item.latest_price" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on"> mdi-information </v-icon>
              </template>
              <span
                >Indicative price is according to the latest purchase
                order.</span
              >
            </v-tooltip>
          </h3>
          <p class="mb-0 text-left">Unit Price</p>
        </v-col>
        <!-- <v-col cols="6" md="4">
          <h3 class="text-left">{{ store_item.tax || 0 }}%</h3>
          <p class="mb-0 text-left">Tax</p>
        </v-col> -->
        <v-col cols="6" md="4">
          <h3 class="text-left">{{ store_item.batch_number || "-" }}
            <v-tooltip v-if="store_item.latest_price" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on"> mdi-information </v-icon>
              </template>
              <span
                >Batch Number is according to the latest GRN.</span
              >
            </v-tooltip>
          </h3>
          <p class="mb-0 text-left">Batch Number</p>
        </v-col>
      </v-row>
    </v-container>

    <v-row class="justify-center mb-2 mt-2">
      <v-tooltip bottom v-if="store_item.has_units && available_counts <= 0">
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="red" dark v-bind="attrs" v-on="on">
            mdi-help-circle
          </v-icon>
        </template>
        <span>Cannot add item units since available quantity is 0.</span>
      </v-tooltip>
      <v-btn
        class="mx-4"
        v-if="store_item.has_units && currentUser.privileges.canAddStoreItems"
        :disabled="available_counts <= 0"
        color="primary"
        rounded
        :to="{
          name: 'AddItemUnit',
          params: { item_id: this.$route.params.item_id },
        }"
        >Add Item Unit</v-btn
      >

      <v-btn
        class="mx-4"
        v-if="currentUser.privileges.canAddPurchaseOrders"
        color="primary"
        id="create-purchase-orders"
        rounded
        :to="{
          name: 'AddItemPurchaseOrder',
          params: {
            store_id: this.$route.params.store_id,
            item_id: this.$route.params.item_id,
          },
        }"
        >Create Purchase Order</v-btn
      >
    </v-row>

    <v-card class="mx-4 my-4" v-if="store_item.has_units">
      <v-card-title>
        Item Units
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <!-- filter -->
      <!-- <v-row class="mx-4">
            <v-col cols="12" md="4">
                <v-select
                v-model="filter.category"
                :items="categories"
                small-chips
                outlined
                color="primary"
                label="Filter by Category"
                multiple
                hide-details
                dense
                background-color="transparent"
                item-value="code"
                item-text="code"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>

            <v-col cols="12" md="4">
                <v-select
                v-model="filter.room"
                :items="rooms"
                small-chips
                outlined
                color="primary"
                label="Filter by Classroom"
                multiple
                hide-details
                dense
                background-color="transparent"
                item-value="id"
                item-text="sections"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-select
                v-model="filter.status"
                :items="['Paid', 'Due', 'Overdue', 'Upcoming']"
                small-chips
                outlined
                color="primary"
                label="Filter by Payment Status"
                multiple
                hide-details
                dense
                background-color="transparent"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>
            </v-row> -->

      <!-- filter end -->
      <v-data-table
        :headers="item_unit_headers"
        :items="item_units"
        :items-per-page="15"
        class="row-pointer"
        @click:row="clickStoreItemUnitRow"
        id="item-details-table"
      >
        <template v-slot:item.arrived_on="{ item }">
          {{
            item.arrived_on
              ? moment(item.arrived_on).format("DD MMM, YYYY")
              : "-"
          }}
        </template>
        <template v-slot:item.unit_price="{ item }">
          {{ item.unit_price ? currencyFormat(item.unit_price) : "-" }}
        </template>
      </v-data-table>
    </v-card>

    <v-card v-if="currentUser.privileges.canViewAllPurchaseOrders" class="mx-4 my-4">
      <v-card-title>
        Purchase Orders
        <v-spacer></v-spacer>
        <v-text-field
          v-model="po_search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <!-- filter -->
      <!-- <v-row class="mx-4">
            <v-col cols="12" md="4">
                <v-select
                v-model="filter.category"
                :items="categories"
                small-chips
                outlined
                color="primary"
                label="Filter by Category"
                multiple
                hide-details
                dense
                background-color="transparent"
                item-value="code"
                item-text="code"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>

            <v-col cols="12" md="4">
                <v-select
                v-model="filter.room"
                :items="rooms"
                small-chips
                outlined
                color="primary"
                label="Filter by Classroom"
                multiple
                hide-details
                dense
                background-color="transparent"
                item-value="id"
                item-text="sections"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-select
                v-model="filter.status"
                :items="['Paid', 'Due', 'Overdue', 'Upcoming']"
                small-chips
                outlined
                color="primary"
                label="Filter by Payment Status"
                multiple
                hide-details
                dense
                background-color="transparent"
                class="mb-4 rounded-input"
                @change="getAllFeeRecords()"
                ></v-select>
            </v-col>
            </v-row> -->

      <!-- filter end -->

      <v-data-table
        :headers="purchase_order_headers"
        :items="purchase_orders"
        :items-per-page="15"
        class="row-pointer"
        @click:row="clickPurchaseOrderRow"
        id="purchase-orders-table-2"
      >
        <template v-slot:item.created="{ item }">
          {{ moment(item.created).format("DD MMM, YYYY") }}
        </template>

        <template v-slot:item.total_amount="{ item }">
          {{ currencyFormat(item.total_amount) }}
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip :color="item.status == 1 ? `red` : `primary`" outlined small class="font-weight-bold">{{
            po_status_mapping[item.status]
          }}</v-chip>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import moment from "moment";
import Helper from "@utils/misc";
import TourHelper from "@utils/tour_helper";


export default {
  name: "InventoryItems",
  data() {
    return {
      moment: moment,

      search: "",
      options: {},
      po_search: "",

      po_options: {},
      pagination: {
        totalCount: 0,
        url:
          endpoints.storeItemUnit +
          "?store_item_id=" +
          this.$route.params.item_id,
      },
      po_pagination: {
        totalCount: 0,
        url:
          endpoints.purchaseOrders +
          "?store_item_id=" +
          this.$route.params.item_id,
      },

      snackbar: {
        visible: false,
        text: "",
      },

      item_unit_headers: [
        { text: "Unit ID", value: "unit_id", align: "center", sortable: false },
        { text: "Name", value: "name", sortable: false },
        {
          text: "Allocated to",
          value: "allocated_to.full_name",
          sortable: false,
        },
      ],
      po_status_mapping: {
        1: "Pending",
        2: "Approved",
        3: "Issued",
      },

      purchase_order_headers: [
        {
          text: "Order No",
          value: "order_number",
          align: "center",
          sortable: false,
        },
        {
          text: "Item Code",
          value: "store_item.code",
          align: "center",
          sortable: false,
        },
        { text: "Item Name", value: "store_item.item_name", sortable: false },
        {
          text: "Order Date",
          value: "created",
          align: "center",
          sortable: false,
        },
        {
          text: "Supplier",
          value: "supplier.supplier_name",
          align: "center",
          sortable: false,
        },
        {
          text: "Store",
          value: "store_item.store.store_name",
          align: "center",
          sortable: false,
        },
        {
          text: "Quantity",
          value: "quantity",
          align: "center",
          sortable: false,
        },
        { text: "Total Amount", value: "total_amount", align: "center" },
        { text: "Status", value: "status", align: "center", sortable: false },
      ],
      store_item: {
        code: null,
        item_name: null,
        store: {
          code: null,
          store_name: null,
          invoice_prefix: null,
          store_type: {
            code: null,
            type_name: null,
            institution: null,
          },
          store_category: {
            code: null,
            category_name: null,
            institution: null,
          },
          institution: null,
          store_items: [],
        },
        quantity: 0,
        available_quantity: 0,
        usage_unit: null,
        unit_price: 0,
        // tax: 0,
        batch_number: null,
        institution: null,
        has_units: false,
        arrived_on: null,
      },
      item_units: [],
      purchase_orders: [],
    };
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },

    available_counts() {
      return this.store_item.quantity - this.item_units.length;
    },

    // available_quantity() {
    //   var allocated_quantity = this.item_units.reduce((a, b) => {
    //     return Boolean(a.alloated_to) + Boolean(b.alloated_to);
    //   }, 0);
    //   return this.item_units.length - allocated_quantity;
    // },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
      var steps = [];
      steps.push({id: '1', title: "Store Items Details!", description: "View All your Store Item related information at this page", videoLink: "https://youtube.com"});
      steps.push({id: '2', description: "Edit your store Item", el: '#edit-storeitem'});
      steps.push({id: '3', description: "Create new purchase order from here", el: '#create-purchase-orders'});
      steps.push({id: '4', description: "View your Item Units that are allocated", el: '#item-details-table'});
      steps.push({id: '5', description: "View your Purchase orders", el: '#purchase-orders-table-2'});
      TourHelper.startTour(this, "storeItem__details", steps);
    },

    async getStoreItemDetails() {
      var url = endpoints.storeItem + this.$route.params.item_id + "/";
      this.store_item = await api.call(this.essentials, url);
    },

    clickPurchaseOrderRow(value) {
      this.$router.push({
        name: "PurchaseOrderDetails",
        params: { po_id: value.id },
      });
    },

    async getStoreItemUnits() {
      var response;
      var url = this.pagination.url;
      if (this.search) {
        url += (url.split("?")[1] ? "&" : "?") + "query=" + this.search;
      }
      response = await api.call(this.essentials, url);
      if (response) {
        this.item_units = response.results;
        this.pagination.totalCount = response.count;
        this.pagination.nextUrl = response.next;
      }
    },

    async getStoreItemPurchaseOrders() {
      var response;
      var url = this.po_pagination.url;
      if (this.po_search) {
        url += (url.split("?")[1] ? "&" : "?") + "query=" + this.po_search;
      }
      response = await api.call(this.essentials, url);
      if (response) {
        this.purchase_orders = response.results;
        this.po_pagination.totalCount = response.count;
        this.po_pagination.nextUrl = response.next;
      }
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    clickStoreItemUnitRow(value) {
      this.$router.push({
        name: "EditItemUnit",
        params: {
          store_id: this.$route.params.store_id,
          item_id: this.$route.params.item_id,
          unit_id: value.id,
        },
      });
    },

    currencyFormat(amount) {
      return Helper.currencyFormat(amount);
    },
  },
  watch: {
    search: {
      async handler() {
        this.options.page = 1;
        var searched = this.search;
        var self = this;
        setTimeout(function () {
          if (searched == self.search) {
            self.getStoreItemUnits();
          }
        }, 500);
      },
    },
    po_search: {
      async handler() {
        this.po_options.page = 1;
        var searched = this.po_search;
        var self = this;
        setTimeout(function () {
          if (searched == self.po_search) {
            self.getStoreItemPurchaseOrders();
          }
        }, 500);
      },
    },
  },
  async created() {
    await this.getStoreItemDetails();
    if (this.store_item.has_units) {
      this.getStoreItemUnits();
    }
    this.getStoreItemPurchaseOrders();
    this.handleTour()
  },
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>